export const FAQ_LIST = [
    {
      id: '1',
      question: '¿Qué es Cantera?',
      answer: 'Somos la comunidad de maestros más grande del Perú, enfocada en darte todo lo que necesitas para seguir creciendo en la chamba.\n\nAquí la idea es simple: que trabajes más ordenado, con más respaldo, y que cada obra te abra más oportunidades.',
      isOpen: true
    },
    {
      id: '2',
      question: '¿Qué gano yo por estar aquí?',
      answer: '• Herramientas para tu chamba\n• Formar parte de un programa de beneficios\n• Capacitaciones para seguir aprendiendo',
      isOpen: true
    }
  ];